"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex items-center gap-4" };
const _hoisted_3 = {
    key: 0,
    class: "text-lg inline-block align-middle"
};
const _hoisted_4 = { class: "inline-block align-middle" };
const _hoisted_5 = {
    key: 0,
    class: "block"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "×", -1);
const _hoisted_8 = [
    _hoisted_7
];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Alert',
    props: {
        title: {
            type: String,
            required: false,
        },
        message: {
            type: String,
        },
        icon: {
            type: Boolean,
            required: false,
            default: false,
        },
        iconClass: {
            type: String,
            required: false,
            default: "marso-icon-notification",
        },
        dismissable: {
            type: Boolean,
            required: false,
            default: false,
        },
        variant: {
            type: String,
            required: false,
            default: "danger",
            validator(value) {
                return ["danger", "warning", "success", "info"].includes(value);
            },
        },
        id: {
            type: String,
            default: () => { var _a; return `alert-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ["dismissed"],
    setup(__props, { emit }) {
        const props = __props;
        const dismissed = (0, vue_3.ref)(false);
        const onDismissed = () => {
            dismissed.value = true;
            emit("dismissed");
        };
        return (_ctx, _cache) => {
            return (!dismissed.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 0,
                    id: __props.id,
                    class: (0, vue_2.normalizeClass)(["text-white p-4 border-0 rounded flex flex-row flex-nowrap items-center justify-between gap-4", {
                            'bg-red': __props.variant === 'danger',
                            'bg-peach': __props.variant === 'warning',
                            'bg-green': __props.variant === 'success',
                            'bg-blue': __props.variant === 'info',
                        }])
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, [
                        (__props.icon)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_3, [
                                (0, vue_2.createElementVNode)("i", {
                                    class: (0, vue_2.normalizeClass)({ [__props.iconClass]: true })
                                }, null, 2)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createElementVNode)("span", _hoisted_4, [
                            (__props.title)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("strong", _hoisted_5, (0, vue_2.toDisplayString)(__props.title), 1))
                                : (0, vue_2.createCommentVNode)("", true),
                            (__props.message)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                    key: 1,
                                    innerHTML: __props.message
                                }, null, 8, _hoisted_6))
                                : (0, vue_2.renderSlot)(_ctx.$slots, "message", { key: 2 })
                        ])
                    ]),
                    (__props.dismissable)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                            key: 0,
                            class: "bg-transparent text-2xl font-semibold leading-none outline-none focus:outline-none",
                            onClick: onDismissed
                        }, _hoisted_8))
                        : (0, vue_2.createCommentVNode)("", true)
                ], 10, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
